import { Auth, API } from 'aws-amplify';
import router from '@/router';

class mainAPI {
  get(path, params) {
    return API.get('api', path, params || {});
  }

  post(path, params) {
    return API.post('api', path, params || {});
  }

  put(path, params) {
    return API.put('api', path, params || {});
  }

  delete(path, params) {
    return API.del('api', path, params || {});
  }

  async guard() {
    const user = await Auth.currentUserInfo();
    if (!user) {
      router.push({
        path: '/signin',
        query: {
          from: router.currentRoute.fullPath,
        },
      });
      return undefined;
    }
    return user;
  }
}

const api = new mainAPI();
export default api;